import script from "./OverviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./OverviewPanel.vue?vue&type=style&index=0&id=aa461c60&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa461c60"]])

export default __exports__